import api from "./api";

export const register = async (userData) => {
    try {
        const response = await api.post('/client/register', userData);

        if (response.data && response.data.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Registration error:", error);
        throw error;
    }
};

export const login = async (username, password, type) => {
    try {
        const response = await api.post('/client/login', { username, password, type });

        if (response.data && response.data.data && response.data.data.token) {
            const token = response.data.data.token;
            localStorage.setItem('token', token);
            if (response.data.success === true) {
                localStorage.setItem('user_data', btoa(JSON.stringify(response.data.data)));
            }
            return response.data;
        } else {
            throw new Error(response.data.message);
        }
    } catch (error) {
        console.error("Login error:", error);
        localStorage.removeItem('token');
        throw error;
    }
};


export const logout = async () => {
    try {
        const token = localStorage.getItem("token");

        if (!token) {
            console.error("No token found");
            return;
        }

        // Call the logout API
        const response = await api.post('/client/logout',
            {},
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        if (response.status === 200) {
            localStorage.removeItem("token");
            localStorage.removeItem("user_data");

            window.location.href = "/login";
        } else {
            console.error("Logout failed:", response.data.message || "Unknown error");
        }
    } catch (error) {
        console.error("Logout error:", error.response?.data || error.message);
    }
};
// export default logout;

export const changePassword = async (current_password, new_password, confirm_password) => {
    try {
        const response = await api.post('/client/change-password', {
            current_password,
            new_password,
            confirm_password
        });
        // if (response.data.success === true) {

        return response.data;
        // } else {
        // throw new Error(response.data.message);
        // }
    } catch (error) {

        console.error('Password change error:', error);
        // throw error;
    }
};

export const otpVerification = async (otp) => {
    try {
        const response = await api.post('/otp-verification', { otp: otp.join('') });
        if (response.data.success === false) {

            throw new Error(response.data.message);
        } else {
            return response.data.data;
        }

    } catch (error) {

        console.error('Error verifying OTP:', error);
        throw error;
    }
};

export const resendOtp = async (mobileNumber) => {
    try {
        const response = await api.post('/send-otp', { mobile_number: mobileNumber });
        if (response.data && response.data.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Registration error:", error);
        throw error;
    }
};

export const setPassword = async (password, user_id) => {
    try {
        const response = await api.post('/forgot-password', { password, user_id });
        if (response.data && response.data.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Registration error:", error);
        throw error;
    }
};

export const searchScript = async (search) => {
    try {
        const response = await api.post('/search-script', { search });
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching Scripts:", error.response ? error.response.data : error.message);
        throw error;
    }
};

export const saveScriptToWatchlist = async (client_id, exchange_id, script_id) => {
    try {
        const response = await api.post('/client/save-watchlist', { client_id, exchange_id, script_id });
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching Scripts:", error.response ? error.response.data : error.message);
        throw error;
    }
};

export const listWatchlist = async () => {
    try {
        const response = await api.post('/client/list-watchlist');
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching Watchlist:", error.response ? error.response.data : error.message);
        throw error;
    }
};

export const listTransaction = async () => {
    try {
        const response = await api.get('/list-transaction');
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching Scripts:", error.response ? error.response.data : error.message);
        throw error;
    }
};

// Ledger master: logged-in client's deposit / withdrawal ledger.
// Pass type = 'deposit' | 'withdraw' to filter, or leave empty for all.
export const getClientLedger = async (type) => {
    try {
        const response = await api.get('/client/ledger', {
            params: type ? { type } : {},
        });
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.error("Error fetching client ledger:", error.response ? error.response.data : error.message);
        throw error;
    }
};